const faderElId = 'fader'
fadeInPage();

function fadeInPage() {
  if (!window.AnimationEvent) return;
  let fader = document.getElementById(faderElId);
  fader.classList.add('fade-out');
}

window.addEventListener('DOMContentLoaded', () => {
  if (!window.AnimationEvent) return;

  const headerLinks = [...document.querySelectorAll("header > a, header > nav a, header [href='/account/login']")];
  const collectionLinks = [...document.querySelectorAll(".collection a")]
  const collectionListLinks = [...document.querySelectorAll(".collection-list a")]
  const productRecommendationLinks = [...document.querySelectorAll("product-recommendations a")]
  const recentlyViewedProductsLinks = [...document.querySelectorAll("recently-viewed-products a")]
  const footerMenuLinks = [...document.querySelectorAll("footer .footer-block--menu a")];

  const targetLinks = [...headerLinks, ...collectionLinks, ...collectionListLinks, ...productRecommendationLinks, ...recentlyViewedProductsLinks, ...footerMenuLinks]

  targetLinks.forEach(anchor => {
    anchor.addEventListener('click', event => {
      let fader = document.getElementById('fader'),
          anchor = event.currentTarget;

      let listener = () => {
        window.location = anchor.href;
        fader.removeEventListener('animationend', listener);
      };
      fader.addEventListener('animationend', listener);

      event.preventDefault();
      fader.classList.add('fade-in');
      setTimeout(() => {fader.classList.remove('fade-in');}, 3000);
    });
  })
});

window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  var fader = document.getElementById('fader');
  fader.classList.remove('fade-in');
});
